import { supabase } from './supabaseClient';

export const BADGES = {
  first_upload: { id: "first_upload", name: "First Steps", emoji: "👟", description: "Upload your first video" },
  three_day_streak: { id: "three_day_streak", name: "On Fire", emoji: "🔥", description: "3 day streak" },
  seven_day_streak: { id: "seven_day_streak", name: "Dedicated", emoji: "💪", description: "7 day streak" },
  ten_uploads: { id: "ten_uploads", name: "Grinder", emoji: "⚙️", description: "Upload 10 videos" },
  level_5: { id: "level_5", name: "Contender", emoji: "🥊", description: "Reach level 5" },
  level_10: { id: "level_10", name: "Champion", emoji: "🏆", description: "Reach level 10" },
};

export const LEVELS = [
  { level: 1, name: "Rookie", minXP: 0 },
  { level: 2, name: "Amateur", minXP: 100 },
  { level: 3, name: "Prospect", minXP: 250 },
  { level: 4, name: "Fighter", minXP: 500 },
  { level: 5, name: "Contender", minXP: 1000 },
  { level: 6, name: "Ranked", minXP: 1750 },
  { level: 7, name: "Elite", minXP: 2750 },
  { level: 8, name: "Master", minXP: 4000 },
  { level: 9, name: "Legend", minXP: 5500 },
  { level: 10, name: "Champion", minXP: 7500 },
];

export function getLevelForXP(xp) {
  let current = LEVELS[0];
  for (const l of LEVELS) {
    if (xp >= l.minXP) current = l;
  }
  return current;
}

export function getNextLevel(xp) {
  const next = LEVELS.find(l => l.minXP > xp);
  return next || null;
}

export function getXPProgress(xp) {
  const current = getLevelForXP(xp);
  const next = getNextLevel(xp);
  if (!next) return 100;
  const range = next.minXP - current.minXP;
  const progress = xp - current.minXP;
  return Math.floor((progress / range) * 100);
}

export async function getOrCreateStats(userId) {
  let { data, error } = await supabase
    .from("fighter_stats")
    .select("*")
    .eq("user_id", userId)
    .single();

  if (error || !data) {
    const { data: newData } = await supabase
      .from("fighter_stats")
      .insert({ user_id: userId })
      .select()
      .single();
    return newData;
  }
  return data;
}

export async function recordUpload(userId) {
  const stats = await getOrCreateStats(userId);
  if (!stats) return null;

  const today = new Date().toISOString().split("T")[0];
  const lastUpload = stats.last_upload;
  const yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];

  let newStreak = 1;
  if (lastUpload === yesterday) {
    newStreak = stats.streak + 1;
  } else if (lastUpload === today) {
    newStreak = stats.streak;
  }

  const XP_PER_UPLOAD = 50;
  const STREAK_BONUS = newStreak > 1 ? newStreak * 10 : 0;
  const newXP = stats.xp + XP_PER_UPLOAD + STREAK_BONUS;
  const newTotalUploads = stats.total_uploads + 1;
  const newLevel = getLevelForXP(newXP).level;

  const newBadges = [...(stats.badges || [])];
  if (newTotalUploads === 1 && !newBadges.includes("first_upload")) newBadges.push("first_upload");
  if (newStreak >= 3 && !newBadges.includes("three_day_streak")) newBadges.push("three_day_streak");
  if (newStreak >= 7 && !newBadges.includes("seven_day_streak")) newBadges.push("seven_day_streak");
  if (newTotalUploads >= 10 && !newBadges.includes("ten_uploads")) newBadges.push("ten_uploads");
  if (newLevel >= 5 && !newBadges.includes("level_5")) newBadges.push("level_5");
  if (newLevel >= 10 && !newBadges.includes("level_10")) newBadges.push("level_10");

  const { data } = await supabase
    .from("fighter_stats")
    .update({
      xp: newXP,
      level: newLevel,
      streak: newStreak,
      last_upload: today,
      total_uploads: newTotalUploads,
      badges: newBadges,
    })
    .eq("user_id", userId)
    .select()
    .single();

  return { stats: data, xpEarned: XP_PER_UPLOAD + STREAK_BONUS, newBadges: newBadges.filter(b => !stats.badges?.includes(b)) };
}
